<template>
  <v-card elevation="2">
    <v-toolbar color="blue-grey darken-2" dark flat>
      <v-icon left>mdi-car-wrench</v-icon>
      <v-toolbar-title>Vehicles & Service History</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('add-vehicle')" v-if="canEdit">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text v-if="vehicles.length === 0" class="text-center py-8">
      <v-icon size="64" color="grey lighten-1">mdi-car</v-icon>
      <p class="text-h6 grey--text mt-4">No vehicles registered</p>
      <v-btn
        color="blue-grey darken-2"
        dark
        @click="$emit('add-vehicle')"
        v-if="canEdit"
      >
        <v-icon left>mdi-plus</v-icon>
        Add First Vehicle
      </v-btn>
    </v-card-text>

    <div v-else>
      <v-expansion-panels>
        <v-expansion-panel v-for="vehicle in vehicles" :key="vehicle.id">
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon left color="blue-grey darken-2">mdi-car</v-icon>
              <div>
                <div class="font-weight-medium">
                  {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
                </div>
                <div class="text-caption grey--text">
                  {{ vehicle.registration }} | {{ vehicle.vin }}
                </div>
              </div>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <div class="mb-2">
                      <strong>Registration:</strong> {{ vehicle.registration }}
                    </div>
                    <div class="mb-2">
                      <strong>VIN:</strong> {{ vehicle.vin }}
                    </div>
                    <div class="mb-2">
                      <strong>Current Mileage:</strong> {{ vehicle.mileage }} km
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-right" v-if="canEdit">
                    <v-btn
                      small
                      color="primary"
                      text
                      @click="$emit('edit-vehicle', vehicle)"
                    >
                      <v-icon left small>mdi-pencil</v-icon>
                      Edit
                    </v-btn>
                    <v-btn
                      small
                      color="red"
                      text
                      @click="$emit('delete-vehicle', vehicle.id)"
                    >
                      <v-icon left small>mdi-delete</v-icon>
                      Delete
                    </v-btn>
                  </v-col>
                </v-row>

                <v-divider class="my-4"></v-divider>

                <div class="d-flex justify-space-between align-center mb-3">
                  <h4>Service History</h4>
                  <v-btn
                    small
                    color="blue-grey darken-2"
                    dark
                    @click="$emit('view-service-history', vehicle.id)"
                  >
                    <v-icon left small>mdi-wrench</v-icon>
                    Add Service
                  </v-btn>
                </div>

                <v-list dense v-if="getServiceHistory(vehicle.id).length > 0">
                  <v-list-item
                    v-for="service in getServiceHistory(vehicle.id)"
                    :key="service.id"
                  >
                    <v-list-item-icon>
                      <v-icon small>mdi-wrench-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        service.service_type
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ formatDate(service.date) }} | {{ getCurrency
                        }}{{ service.cost }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <p v-else class="text-center grey--text py-4">
                  No service history yet
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "VehicleServiceFiles",

  props: {
    vehicles: {
      type: Array,
      default: () => [],
    },
    serviceHistory: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: "R",
    },
  },

  computed: {
    getCurrency() {
      return this.currency;
    },
  },

  methods: {
    getServiceHistory(vehicleId) {
      return this.serviceHistory.filter((s) => s.vehicle_id === vehicleId);
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>
